import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function SitemarkIcon(height=21, width=100) {
  return (
    <SvgIcon sx={{ height: height, width: width, mr: 2 }}>
      <svg
      style={{ width: width, height: height}}
width="86"  viewBox="0 0 900.000000 293.000000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >

<g transform="translate(0.000000,293.000000) scale(0.100000,-0.100000)"
fill="#08313d" stroke="none">
<path d="M540 2658 c-95 -41 -212 -151 -254 -242 -57 -124 -57 -113 -54 -994
l3 -807 23 -60 c68 -181 228 -320 407 -355 43 -8 270 -10 795 -8 735 3 735 3
795 26 129 48 243 149 299 265 57 117 56 104 56 964 0 533 -4 809 -11 845 -30
146 -148 296 -286 361 l-68 32 -815 2 -815 3 -75 -32z m1237 -561 c72 -34 105
-65 131 -127 61 -139 18 -306 -119 -469 -119 -141 -236 -223 -405 -282 -191
-67 -385 -187 -552 -343 -50 -47 -96 -86 -102 -86 -30 0 17 179 86 329 85 184
260 395 462 556 l100 79 -62 73 c-35 40 -117 123 -184 184 -67 61 -122 113
-122 115 0 3 159 4 353 2 l352 -3 62 -28z m194 -830 c71 -48 111 -154 89 -239
-16 -60 -64 -131 -110 -163 -82 -57 -99 -59 -438 -63 -281 -3 -316 -2 -339 14
-32 20 -30 22 93 65 222 78 344 152 505 306 120 114 138 122 200 80z"/>
<path d="M6855 2109 c-82 -23 -121 -129 -73 -199 47 -70 143 -77 205 -15 28
28 33 40 33 79 0 64 -23 104 -73 127 -47 21 -49 21 -92 8z"/>
<path d="M3074 2063 l-61 -4 -7 -572 c-3 -315 -9 -584 -12 -599 -4 -18 0 -32
13 -45 18 -18 37 -20 243 -21 358 -3 444 15 548 112 103 97 136 252 78 370
-29 60 -81 110 -151 147 -25 13 -45 27 -45 30 0 3 11 11 24 17 46 21 104 82
127 135 17 40 22 71 22 132 1 98 -27 161 -98 223 -79 70 -107 75 -380 77 -132
1 -267 0 -301 -2z m448 -203 c20 -6 50 -26 67 -46 26 -29 31 -43 31 -87 0 -61
-25 -109 -67 -130 -39 -21 -149 -31 -240 -22 l-76 7 7 135 c4 75 9 140 12 144
7 12 221 11 266 -1z m21 -501 c143 -39 165 -228 36 -304 -29 -17 -56 -20 -185
-23 l-151 -4 -6 54 c-9 70 -9 273 0 281 11 11 265 8 306 -4z"/>
<path d="M5881 2061 c-12 -8 -15 -102 -16 -610 -1 -331 2 -606 6 -613 9 -14
132 -23 184 -14 l35 7 0 141 c0 137 1 141 26 172 15 17 33 35 40 39 10 6 45
-40 130 -168 111 -165 120 -176 158 -186 38 -10 174 -6 219 7 37 11 35 14
-195 341 -70 100 -128 187 -128 192 0 5 70 78 155 162 85 84 155 160 155 170
0 25 -22 29 -122 22 l-92 -6 -112 -106 c-61 -58 -135 -132 -164 -163 -87 -96
-84 -107 -76 276 7 304 6 334 -9 340 -25 9 -178 7 -194 -3z"/>
<path d="M4265 1747 c-55 -19 -154 -71 -189 -100 -23 -18 -28 -29 -23 -48 9
-36 75 -109 99 -109 11 0 46 16 77 35 144 89 291 59 321 -65 6 -27 9 -53 6
-58 -3 -5 -52 -12 -108 -16 -242 -17 -361 -67 -421 -180 -18 -33 -22 -58 -22
-132 0 -83 2 -94 30 -139 40 -65 103 -103 191 -117 102 -16 196 2 274 53 33
21 63 39 65 39 3 0 12 -17 20 -37 9 -21 21 -41 28 -45 19 -12 142 -9 154 3 18
18 6 638 -12 705 -21 73 -80 135 -171 180 -69 34 -82 38 -177 41 -67 2 -116
-2 -142 -10z m285 -598 c0 -76 -2 -82 -29 -108 -37 -35 -92 -51 -170 -51 -56
0 -66 3 -92 29 -24 24 -29 38 -29 75 0 90 79 134 243 135 l77 1 0 -81z"/>
<path d="M5337 1750 c-45 -12 -100 -39 -146 -74 -44 -33 -48 -33 -56 4 -4 17
-15 35 -25 40 -27 14 -153 12 -172 -2 -15 -12 -17 -61 -20 -441 -3 -500 -14
-457 115 -457 129 0 119 -28 116 325 -3 346 -9 321 87 376 95 54 197 47 239
-17 25 -39 32 -148 27 -410 l-4 -241 23 -17 c17 -11 45 -16 97 -16 125 0 116
-32 108 358 -8 381 -13 413 -77 486 -22 25 -59 52 -90 65 -58 25 -165 35 -222
21z"/>
<path d="M8295 1737 c-164 -55 -265 -167 -301 -335 -25 -120 -11 -247 40 -358
50 -109 171 -205 295 -234 71 -17 191 -8 263 20 174 65 274 209 286 407 9 172
-35 299 -139 398 -88 84 -148 107 -289 111 -77 3 -128 -1 -155 -9z m201 -182
c92 -27 145 -112 152 -244 11 -204 -64 -316 -213 -316 -109 0 -174 56 -210
180 -19 63 -16 175 5 246 17 60 77 119 135 134 65 18 72 18 131 0z"/>
<path d="M6812 1717 l-34 -12 -3 -432 -4 -431 31 -11 c42 -15 147 -14 178 2
l25 13 -3 429 c-3 380 -6 431 -20 443 -20 15 -126 15 -170 -1z"/>
<path d="M7115 1717 c-23 -18 -36 26 139 -472 142 -404 141 -401 177 -415 34
-14 223 -10 239 6 5 5 78 202 161 438 177 500 174 460 26 454 -59 -3 -92 -9
-101 -19 -8 -8 -51 -135 -95 -284 -96 -317 -111 -360 -121 -348 -5 4 -54 149
-110 320 -56 172 -107 316 -113 320 -7 4 -50 9 -97 11 -64 3 -90 0 -105 -11z"/>
</g>
</svg>
    </SvgIcon>
  );
}
